module.exports = __webpack_public_path__ + "static/media/startman.f299d98e.svg";